import { useState } from "react"
import { Search, Filter, Star, ShoppingCart, Heart, Share2 } from "lucide-react"
import CommunityBanner from "./CommunityBanner"

const categories = ["All", "Courses", "eBooks", "Templates", "Merchandise", "Services"]

const products = [
  {
    id: 1,
    name: "Advanced React Course",
    description: "Master React with our comprehensive course",
    price: 99.99,
    rating: 4.8,
    reviews: 145,
    category: "Courses",
    image: "/placeholder.svg?height=300&width=400",
  },
  {
    id: 2,
    name: "Web Development Guide",
    description: "Complete guide to modern web development",
    price: 29.99,
    rating: 4.9,
    reviews: 283,
    category: "eBooks",
    image: "/placeholder.svg?height=300&width=400",
  },
  // Add more products...
]

// export function CommunityStorePage() {
//   const [selectedCategory, setSelectedCategory] = useState("All")
//   const [sortBy, setSortBy] = useState("popular")

//   return (
//     <div className="space-y-6 max-w-[2000px] mx-auto px-4 sm:px-6 lg:px-8">
//       <CommunityBanner />

//       {/* Search and Filters */}
//       <div className="flex flex-col sm:flex-row gap-4">
//         <div className="relative flex-1">
//           <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
//           <input
//             type="search"
//             placeholder="Search products..."
//             className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200  bg-white  focus:outline-none focus:ring-2 focus:ring-indigo-500"
//           />
//         </div>
//         <div className="flex gap-2">
//           <select
//             value={sortBy}
//             onChange={(e) => setSortBy(e.target.value)}
//             className="px-4 py-2 rounded-lg border border-gray-200  bg-white  focus:outline-none focus:ring-2 focus:ring-indigo-500"
//           >
//             <option value="popular">Most Popular</option>
//             <option value="recent">Most Recent</option>
//             <option value="price-low">Price: Low to High</option>
//             <option value="price-high">Price: High to Low</option>
//           </select>
//           <button className="inline-flex items-center px-4 py-2 bg-white  border border-gray-200  rounded-lg hover:bg-gray-50  transition-colors">
//             <Filter className="w-5 h-5 mr-2" />
//             Filters
//           </button>
//         </div>
//       </div>

//       {/* Categories */}
//       <div className="flex gap-2 overflow-x-auto pb-2 -mx-2 px-2 scrollbar-hide">
//         {categories.map((category) => (
//           <button
//             key={category}
//             onClick={() => setSelectedCategory(category)}
//             className={`
//               flex items-center px-3 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors
//               ${
//                 selectedCategory === category
//                   ? "bg-indigo-600 text-white"
//                   : "bg-white  text-gray-700  hover:bg-gray-50 "
//               }
//             `}
//           >
//             {category}
//           </button>
//         ))}
//       </div>

//       {/* Products Grid */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//         {products.map((product) => (
//           <div
//             key={product.id}
//             className="bg-white  rounded-xl overflow-hidden hover:shadow-lg transition-shadow group"
//           >
//             {/* Product Image */}
//             <div className="aspect-[4/3] relative group">
//               <img
//                 src={product.image || "/placeholder.svg"}
//                 alt={product.name}
//                 className="w-full h-full object-cover"
//               />
//               <div className="absolute inset-0 bg-black/60 flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
//                 <button className="p-2 bg-white  rounded-lg hover:bg-gray-100  transition-colors">
//                   <Heart className="w-5 h-5" />
//                 </button>
//                 <button className="p-2 bg-white  rounded-lg hover:bg-gray-100  transition-colors">
//                   <Share2 className="w-5 h-5" />
//                 </button>
//               </div>
//             </div>

//             {/* Product Content */}
//             <div className="p-4">
//               <div className="flex items-center justify-between mb-2">
//                 <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-indigo-50  text-indigo-600 ">
//                   {product.category}
//                 </span>
//                 <div className="flex items-center gap-1 text-yellow-500">
//                   <Star className="w-4 h-4 fill-current" />
//                   <span className="text-sm">{product.rating}</span>
//                 </div>
//               </div>

//               <h3 className="font-semibold text-lg mb-1">{product.name}</h3>
//               <p className="text-sm text-gray-500  mb-4">{product.description}</p>

//               <div className="flex items-center justify-between">
//                 <span className="text-lg font-bold">${product.price}</span>
//                 <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors">
//                   <ShoppingCart className="w-5 h-5" />
//                   Add to Cart
//                 </button>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   )
// }

export function CommunityStorePage() {
  return (
    <div className="flex items-center justify-center h-[80vh] max-w-[2000px] mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-gray-800">Community Store</h1>
        <p className="text-lg text-gray-600">Exciting things are on the way.</p>
        <span className="inline-block px-4 py-2 bg-indigo-100 text-indigo-600 font-medium rounded-full">
          Coming Soon
        </span>
      </div>
    </div>
  )
}
